export default {
      id: "common__edit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__edit",
      toString: function () {
        return this.url;
      }
    }